module.exports = __webpack_public_path__ + "static/img/omron-healthcare-thumb.8687f1f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/pjmove-thumbs/omron-healthcare-thumb.jpg
// module id = Y1Z5
// module chunks = 0